import * as graphql from 'generated/graphql';
import { Spinner } from '@treams/treams-ui';
import EvaluationSubmissionComponent from './components/EvaluationSubmission';
import EvaluationSubmissionSidebarLayout from './components/layout/EvaluationSubmissionSidebarLayout';
import { Button, Toolbar } from '@treams/treams-ui';
import { ChevronLeftIcon } from '@treams/treams-icons';
import { t } from 'i18next';
import { useState } from 'react';
import { Box } from 'reflexbox';
import LayoutSection from './components/layout/LayoutSection';
import { Flex } from '@mantine/core';
import useDetectPrint from './hooks/useDetectPrint';

export default function EvaluationSubmission(props: {
	evaluationSubmissionID: string;
	onCompleted?: () => void;
	returnUrl?: string;
}) {
	const isPrinting = useDetectPrint();
	const [isSidebarOpen, setIsSidebarOpen] = useState(!isPrinting);

	const { data, loading, refetch } = graphql.useEvaluationSubmissionQuery({
		variables: {
			id: props.evaluationSubmissionID,
		},
		onCompleted: () => {
			props.onCompleted?.();
		},
	});

	if (loading || !data) {
		return (
			<Flex align="center" justify="center" p="60px">
				<Spinner size="18px" />
			</Flex>
		);
	}

	return (
		<EvaluationSubmissionSidebarLayout
			id={props.evaluationSubmissionID}
			user={data.evaluationSubmission.employee.user as graphql.User}
			onSidebarOpen={(newValue) => setIsSidebarOpen(newValue)}
			isSideBarOpen={isSidebarOpen}
		>
			<Box py={4}>
				{!isPrinting && (
					<LayoutSection>
						<Toolbar mb={30}>
							<Button
								icon={<ChevronLeftIcon />}
								link={props.returnUrl}
								title={t('goals.show.toolbar.back')}
								type="secondary"
							/>
						</Toolbar>
					</LayoutSection>
				)}

				<EvaluationSubmissionComponent
					submission={data.evaluationSubmission}
					onRefresh={refetch}
					isSidebarOpen={isSidebarOpen}
				/>
			</Box>
		</EvaluationSubmissionSidebarLayout>
	);
}
